var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'sub-title-center': _vm.select === true,
    'sub-title-left': _vm.select === false
  }},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"title-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }